$(document).ready(function(){
  // Check global root font size
  if ( localStorage.getItem('fontSize') == 'default' ) {
    $('.navbar--sub .nav-main').removeClass('bigger');
    $('html').css("font-size", "10px");
    $('.navbar__logo').removeClass('onTop');
    $('.fontDefault').addClass('active');
  }
  else if ( localStorage.getItem('fontSize') == 'bigger' ) {
    $('html').css("font-size", "12px");
    $('.navbar--sub .nav-main').addClass('bigger');
    $('.navbar__logo').addClass('onTop');
    $('.fontBigger').addClass('active');
  }
  else if ( localStorage.getItem('fontSize') == 'big' ) {
    $('html').css("font-size", "14px");
    $('.navbar--sub .nav-main').addClass('bigger');
    $('.navbar__logo').addClass('onTop');
    $('.fontBig').addClass('active');
  } else {
    $('.fontDefault').addClass('active');
  }

  Menu();
  // Navbar();

    //do something special
    goToSubMenu();

    moveToTop();

    // if(window.matchMedia('(max-width: 599px)').matches){
    //   //hide show category nav
    //   $('.subnavbar__logo img');
    //   $('.subnavbar__logo img').attr('src', 'https://everywhere.pl/www/baletcolor/www/wp-content/themes/balet/images/icons/logo-circle.svg');
    //   $('.navbar__logo-box img').attr('src', 'https://everywhere.pl/www/baletcolor/www/wp-content/themes/balet/images/icons/logo-circle.svg');
    // }else{
    //   $('.subnavbar__logo img').attr('src', 'https://everywhere.pl/www/baletcolor/www/wp-content/themes/balet/images/icons/logo_1.svg');
    //   $('.navbar__logo-box img').attr('src', 'https://everywhere.pl/www/baletcolor/www/wp-content/themes/balet/images/icons/logo_1.svg');
    // }


    var $OpenGalleryLink = $('a[data-lightbox]').on('click', makeMinHeightOnOpenGallery);

    $(document).scroll(function() {
      var scrollTop = $(window).scrollTop();
        if (scrollTop >= 100 ) {
           $('.navbar:not(.navbar--active)').addClass("navbar--scroll");
        }
        else{
            $('.navbar:not(.navbar--active)').removeClass("navbar--scroll");
        }
    });



  var imgTarget = $('#gallery-img');
  if ($('.dancers').length > 0) {
    $('#gallery img').on('click', function(){
      changeDancers(imgTarget, $(this));
    });
  }

  $('.events__menu button').on('click', function(e){
    e.preventDefault();
    changeSubMenu($(this));
  });


  $('.slider-main__button').on('click', function() {
    $('html, body').animate({
        scrollTop: $('main').offset().top - 70
      }, 800);
  });




  var slideWrapper = $(".main-slider"),
      iframes = slideWrapper.find('.embed-player'),
      lazyImages = slideWrapper.find('.slide-image'),
      lazyCounter = 0;

  // POST commands to YouTube or Vimeo API
  function postMessageToPlayer(player, command){
    if (player == null || command == null) return;
    player.contentWindow.postMessage(JSON.stringify(command), "*");
  }

  // When the slide is changing
  function playPauseVideo(slick, control){
    var currentSlide, slideType, startTime, player, video;

    currentSlide = slick.find(".slick-current");
    slideType = currentSlide.attr("class").split(" ")[1];
    player = currentSlide.find("iframe").get(0);
    startTime = currentSlide.data("video-start");

    if (slideType === "vimeo") {
      switch (control) {
        case "play":
          if ((startTime != null && startTime > 0 ) && !currentSlide.hasClass('started')) {
            currentSlide.addClass('started');
            postMessageToPlayer(player, {
              "method": "setCurrentTime",
              "value" : startTime
            });
          }
          postMessageToPlayer(player, {
            "method": "play",
            "value" : 1
          });
          break;
        case "pause":
          postMessageToPlayer(player, {
            "method": "pause",
            "value": 1
          });
          break;
      }
    } else if (slideType === "youtube") {
      slideWrapper.slick('slickPause');
      setTimeout(function () {
        moveSlider();
        slideWrapper.slick('slickPlay');
        player.src = player.src;
      }, 100000);
      switch (control) {
        case "play":
          postMessageToPlayer(player, {
            "event": "command",
            "func": "mute"
          });
          postMessageToPlayer(player, {
            "event": "command",
            "func": "playVideo"
          });
          break;
        case "pause":
          postMessageToPlayer(player, {
            "event": "command",
            "func": "pauseVideo"
          });
          break;
      }
    } else if (slideType === "video") {
      video = currentSlide.children("video").get(0);
      if (video != null) {
        if (control === "play"){
          video.play();
        } else {
          video.pause();
        }
      }
    }
  };


  // Resize player
  function resizePlayer(iframes, ratio) {
    if (!iframes[0]) return;
    var win = $(".main-slider"),
        width = win.width(),
        playerWidth,
        height = win.height(),
        playerHeight,
        ratio = ratio || 16/9;

    iframes.each(function(){
      var current = $(this);
      if (width / ratio < height) {
        playerWidth = Math.ceil(height * ratio);
        current.width(playerWidth).height(height).css({
          left: (width - playerWidth) / 2,
           top: 0
          });
      } else {
        playerHeight = Math.ceil(width / ratio);
        current.width(width).height(playerHeight).css({
          left: 0,
          top: (height - playerHeight) / 2
        });
      }
    });
  }

  // DOM Ready

    // Initialize
    slideWrapper.on("init", function(slick){
      slick = $(slick.currentTarget);
      setTimeout(function(){
        $('.slider-box').css('background', 'none');
        playPauseVideo(slick,"play");
      }, 1000);
      resizePlayer(iframes, 16/9);
    });
    slideWrapper.on("beforeChange", function(event, slick) {
      slick = $(slick.$slider);
      playPauseVideo(slick,"pause");

    });
    slideWrapper.on("afterChange", function(event, slick) {
      slick = $(slick.$slider);
      playPauseVideo(slick,"play");


    });
    slideWrapper.on("lazyLoaded", function(event, slick, image, imageSource) {
      lazyCounter++;
      if (lazyCounter === lazyImages.length){
        lazyImages.addClass('show');
        // slideWrapper.slick("slickPlay");
      }
    });

    //start the slider
    slideWrapper.slick({
      fade:true,
      autoplaySpeed:5000,
      lazyLoad:"progressive",
      speed:600,
      arrows:false,
      dots:true,
      accessibility: true,
      pauseOnHover:false,
      cssEase:"cubic-bezier(0.87, 0.03, 0.41, 0.9)"
      // autoplay: true
    });
    slideWrapper.slick('slickPlay');

    slideWrapper.on('click', function(){
      moveSlider();
    });



    function moveSlider(){
      slideWrapper.slick('slickNext');
    }

  // Resize event
  $(window).on("resize.slickVideoPlayer", function(){
    resizePlayer(iframes, 16/9);
  });

  // Audio player
  if ( $('.audio__play')[0] ) {
    $('.audio__play').audioPlayer();
  }

  // Font resize buttons
  $('.fontButton').on('click', function() {
    if ( !$(this).hasClass('active') ) {
      $('.fontButton.active').removeClass('active');
      $(this).addClass('active');
    }
  });

  $('.fontDefault').on('click', function() {
    $('html').css("font-size", "10px");
    $('.navbar--sub .nav-main').removeClass('bigger');
    $('.navbar__logo').removeClass('onTop');
    $('.fontButton').removeClass('active');
    $(this).addClass('active');
    localStorage.setItem('fontSize', 'default');
  });

  $('.fontBigger').on('click', function() {
    $('html').css("font-size", "12px");
    $('.navbar--sub .nav-main').addClass('bigger');
    $('.navbar__logo').addClass('onTop');
    $('.fontButton').removeClass('active');
    $(this).addClass('active');
    localStorage.setItem('fontSize', 'bigger');
  });

  $('.fontBig').on('click', function() {
    $('html').css("font-size", "14px");
    $('.navbar--sub .nav-main').addClass('bigger');
    $('.navbar__logo').addClass('onTop');
    $('.fontButton').removeClass('active');
    $(this).addClass('active');
    localStorage.setItem('fontSize', 'big');
  });

  // Contrast button
  $('#contrastBtn').on('click', function() {
    if ( $('html').hasClass('contrast') ) {
      $('.navbar__logo img').attr('src', translations.home_url+'/wp-content/themes/balet/images/icons/logo_1.svg');
      $('.footer__logo').attr('src', translations.home_url+'/wp-content/themes/balet/images/icons/footer-logo.png');
      
    }
    else {
      $('.footer__logo').attr('src', translations.home_url+'/wp-content/themes/balet/images/icons/footer-logo_contrast.png');
      $('.navbar__logo img').attr('src', translations.home_url+'/wp-content/themes/balet/images/icons/logo_1_contrast.svg');
    }
    
    $('html').toggleClass('contrast');
    if ( localStorage.getItem('isContrast') == 'true' ) { 
      localStorage.setItem('isContrast', 'false');
    } else {
      localStorage.setItem('isContrast', 'true');
    }
  });

  // Fancybox gallery
  $('#slideshow-start').on('click', function() {
    $.fancybox.open( $('.fb-item'), {
      baseTpl:
      '<div class="fancybox-container" role="dialog" tabindex="-1">' +
      '<div class="fancybox-bg"></div>' +
      '<div class="fancybox-inner">' +
      '<div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div>' +
      '<div class="fancybox-toolbar">{{buttons}}</div>' +
      '<div class="fancybox-stage"></div>' +
      '<div class="fancybox-caption"><div class=""fancybox-caption__body"></div></div>' +
      '</div>' +
      '</div>',
      buttons: [
        // "zoom",
        // "share",
        "slideShow",
        // "fullScreen",
        // "download",
        // "thumbs",
        // "close"
      ],
      btnTpl: {
        slideShow: '<button data-fancybox-play class="fancybox-button fancybox-button--play" title="{{PLAY_START}}">' +
        '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M6.5 5.4v13.2l11-6.6z"/></svg>' +
        '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M8.33 5.75h2.2v12.5h-2.2V5.75zm5.15 0h2.2v12.5h-2.2V5.75z"/></svg>' +
        "</button>"
      },
      lang: "pl",
      i18n: {
        pl: {
          CLOSE: "Zamknij",
          NEXT: "Następny",
          PREV: "Poprzedni",
          ERROR: "Zawartość nie mogła zostać wczytana. <br/> Spróbuj ponownie później.",
          PLAY_START: "Start",
          PLAY_STOP: "Pauza",
          FULL_SCREEN: "Pełen ekran",
          THUMBS: "Kafelki",
          DOWNLOAD: "Pobierz",
          SHARE: "Udostępnij",
          ZOOM: "Powiększ"
        }
      },
      afterLoad: function( instance, current ) {
        if ( instance.group.length > 1 && current.$content ) {
          current.$content.append('<button data-fancybox-next class="fancybox-arrow fancybox-arrow--next"><span class="sr-only">Następny</span></button><button data-fancybox-prev class="fancybox-arrow fancybox-arrow--prev"><span class="sr-only">Poprzedni</span></button>');
        }
        current.$content.append('<button data-fancybox-close class="fancybox-close"><span class="sr-only">Zamknij</span></button>');
        current.$content.append('<button data-fancybox-fullscreen class="fancybox-fullscreen"><span class="sr-only">Pełny ekran</span></button>');
      },
      idleTime: false
    });
  });

  // Main slider stop/play button
  // $('#main-slider-pause').on('click', function() {
  //   if ( $(this).hasClass('active') ) {
  //     $('.slider-main').slick('slickPlay');
  //     $('.pause__icon--play').hide();
  //     $('.pause__icon--pause').show();
  //     $('.pause__text').text('Zatrzymaj');
  //   } else {
  //     $('.slider-main').slick('slickPause');
  //     $('.pause__icon--pause').hide();
  //     $('.pause__icon--play').show();
  //     $('.pause__text').text('Wznów');
  //   }
  //   $(this).toggleClass('active');
  // });

});

var Menu = function(){
  var $burger = $('#burger');
  var $navbar = $('.navbar');
  $burger.on('click', function(e){
    $navbar.toggleClass('navbar--active');
    $burger.toggleClass('navbar__icon--burger--active');
    e.preventDefault();
  });

}

// function Navbar(){
//   var $header = $('.navbar'),
//       navTop = $header.offset().top,
//       $window = $(window);
//       if($window.width() > 767){
//         $(window).on('scroll', function(){
//           if($(window).scrollTop() >= 50){
//             $header.find('.navbar__logo-box').addClass('navbar__logo-box--scroll');
//             $header.addClass('navbar--scroll');
//           }else{
//             $header.find('.navbar__logo-box').removeClass('navbar__logo-box--scroll');
//             $header.removeClass('navbar--scroll');
//           }
//         });
//       }
// }
//
//


//sliders
// var $slickMain = $('.slider-main');
// $slickMain.slick({
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   autoplay: true,
//   autoplaySpeed: 4000,
//   accessibility: false,
//   arrows: true,
//   fade: true,
//   speed: 1000,
//   pauseOnHover: false
  // nav: true,
  // nextArrow: '<button type="button" class="slick-prev slider-main__arrow slider-main__arrow--next"></button>',
  // prevArrow: '<button type="button" class="slick-next slider-main__arrow slider-main__arrow--prev"></button>',
// });








var $slick2cols = $('.slider-2cols');
$slick2cols.prev().css("width", "75%");
$slick2cols.slick({
  slidesToShow: 2,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 4000,
  arrows: true,
  nav: true,
  nextArrow: '<button type="button" class="slick-prev slider-2cols__arrow slider-2cols__arrow--next"><span class="sr-only">' + translations.nextSlide + '</span></button>',
  prevArrow: '<button type="button" class="slick-next slider-2cols__arrow slider-2cols__arrow--prev"><span class="sr-only">' + translations.prevSlide + '</span></button>',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});



var $slick4cols = $('.slider-4cols');
$slick4cols.prev().css("width", "75%");
$slick4cols.slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 4000,
  arrows: true,
  nav: true,
  nextArrow: '<button type="button" class="slick-prev slider-2cols__arrow slider-2cols__arrow--next"><span class="sr-only">'+ translations.nextSlide +'</span></button>',
  prevArrow: '<button type="button" class="slick-next slider-2cols__arrow slider-2cols__arrow--prev"><span class="sr-only">'+ translations.prevSlide +'</span></button>',
  responsive: [
    {
      breakpoint: 1201,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 601,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});

var $slick2text = $('.slider-2text');
// $slick2cols.prev().css("width": "75%");
$slick2text.slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 4000,
  arrows: true,
  nav: true,
  nextArrow: '<button type="button" class="slick-prev slider-2cols__arrow slider-2cols__arrow--next"><span class="sr-only">' + translations.nextSlide + '</span></button>',
  prevArrow: '<button type="button" class="slick-next slider-2cols__arrow slider-2cols__arrow--prev"><span class="sr-only">' + translations.prevSlide + '</span></button>'
});



var changeSubMenu = function(target){
  target.parent().siblings().children().removeClass('active');
  target.addClass('active');
  var $attr = target.data('show');
  window.location.hash = $attr;
  $('#' + $attr).siblings().hide(200);
  $('#' + $attr).show(400);

}

var goToSubMenu = function(event){

  // scrollTo if #_ found
  hashname = window.location.hash.replace('#_', '');
  // find element to scroll to (<a name=""> or anything with particular id)
  if(hashname){
    elem = $(hashname);
    var navElem = hashname.substring(1);

    if(elem){
      console.log(elem);
      $('.events__menu li button[data-show="' + navElem + '"]').addClass('active');
      elem.siblings().hide(200);
      elem.show(400);
      setTimeout(
        function()
        {
          $('html, body').animate({
            scrollTop: 0
          }, 0);
        }, 0);
    }
  }else if ($('.events__menu li button').length == 1) {
    $('.events__menu li button[data-show]').addClass('active');

    window.location.hash = $('.events__menu li button').eq(0).data('show');
  }else{
    $('.events__menu li button[data-show="description"]').addClass('active');
  }

}

var moveToTop = function(){
  $('.footer__button').on('click', function(){
    var offTop = $('body').offset().top - $('.navbar').outerHeight() - 20;
    $('html, body').animate({
        scrollTop: offTop
      }, 800);
  })
};

var changeDancers = function(target, image){
  var source = image.data('image');
  target.find('img').attr('src', source);
  if(window.matchMedia('(max-width: 1024px)').matches){
    var targetOff = target.offset().top - $('.navbar').outerHeight(true) + 'px'
    $('html, body').animate({
        scrollTop: targetOff
      }, 300);
  }
}


var makeMinHeightOnOpenGallery = function(){
  setTimeout(
  function()
  {
    var imgheight = $('#lightbox2 .lb-outerContainer2').innerHeight();

    $('#gallery').css('min-height', imgheight + 50 + 'px');
  }, 500);
}
